/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

/* eslint-disable array-callback-return */
import React from 'react';
import PropTypes from 'prop-types';

import { formatPrice } from '../../../utils/formater';
import { isEmpty } from '../../../utils/object';

class OrderSummaryHelper extends React.Component {
    render() {
        const {
            data: { orderDetailById, giftCardPayments },
        } = this.props;

        const orderSummary = {
            subTotal: { label: 'Subtotal', price: 0 },
            promotionDiscountAmount: { label: 'Promotion Discount', price: 0 },
            shippingCharge: { label: 'Shipping / Service Charge', price: 0 },
            tax: { label: 'Tax', price: 0 },
            giftCardAmount: { label: 'Gift Card', price: 0 },
            totalCharge: { label: 'Order Total', price: 0 },
        };

        orderDetailById.forEach((billing) => {
            const { billingDetail: billDetail, itemDetailList } = billing;
            orderSummary.promotionDiscountAmount.price += Number(billDetail.promotionDiscountAmount);
            orderSummary.shippingCharge.price += Number(billDetail.serviceCharge);
            orderSummary.shippingCharge.price += Number(billDetail.shippingCharge);
            orderSummary.shippingCharge.price += Number(billDetail.surcharge);
            orderSummary.tax.price += Number(billDetail.tax);
            orderSummary.totalCharge.price += Number(billDetail.totalCharge);

            if (!isEmpty(giftCardPayments)) {
                giftCardPayments.forEach((giftcard) => {
                    orderSummary.giftCardAmount.price += Number(giftcard.giftCardAmount);
                });
            }

            itemDetailList.forEach((item) => {
                orderSummary.subTotal.price += Number(item.price);
            });
        });

        // // Reset totalCharge to 0 if it < $1 with gift card payments
        // if (
        //     orderSummary.totalCharge.price < 1 &&
        //     orderSummary.totalCharge.price > 0
        // ) {
        //     if (
        //         orderSummary.giftCardAmount.price > 0 &&
        //         !cardType &&
        //         !cardNumber &&
        //         !thirdPartyType
        //     ) {
        //         // orderSummary.giftCardAmount.price +=
        //         //     orderSummary.totalCharge.price;
        //         orderSummary.totalCharge.price = 0;
        //     }
        // }

        return (
            <div className="summary-info margin-bottom">
                {Object.keys(orderSummary).map((key) => {
                    if (
                        (key === 'promotionDiscountAmount'
                            || key === 'giftCardAmount')
                        && orderSummary[key].price === 0
                    ) {
                        return '';
                    }
                    return (
                        <React.Fragment key={key}>
                            <div className="split">
                                <div className="summary-label">
                                    {orderSummary[key].label}:
                                </div>
                                <div className="summary-price">
                                    {key === 'promotionDiscountAmount'
                                    || key === 'giftCardAmount'
                                        ? '-'
                                        : ''}
                                    ${formatPrice(orderSummary[key].price)}
                                </div>
                            </div>
                        </React.Fragment>
                    );
                })}
            </div>
        );
    }
}

OrderSummaryHelper.propTypes = {
    data: PropTypes.object.isRequired,
};

export default OrderSummaryHelper;
